export default "__VITE_ASSET__ff28729a__"